import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "../component/Header/Header";
import Home from "../component/pages/Home/Home";
import Footer from "../component/Footer/Footer";
import Track from "../component/pages/trackorder/Track";
import About from "../component/pages/about/About";
import Privacypolicy from "../component/pages/privacy/Privacypolicy";
import Terms from "../component/pages/Terms of use/Terms";
// import Contact from "../component/pages/Contact us/Contact";

const Router = () => {
  return (
    <div>
      <BrowserRouter>
      <Header/>
        <Routes>
          <Route path="/" element={<Home/>}></Route>
          {/* <Route path="/contact" element={<Contact/>}/> */}
          <Route path="/trackorder" element={<Track/>}></Route>
          <Route path="/about" element={<About/>}></Route>
          <Route path="/privacy-policy" element={<Privacypolicy/>}></Route>
          <Route path="/terms" element={<Terms/>}></Route>
          
          
        </Routes>
        <Footer/>
      </BrowserRouter>
    </div>
  );
};

export default Router;
